import {createStore, applyMiddleware} from 'redux';
import {appReducer} from './reducer';
import {Configs} from '../configs';
import persistStore from 'redux-persist/es/persistStore';

const crashReporter = store => next => action => {
    try {
        return next(action);
    } catch (err) {
        console.error('Caught an exception!', err);
        console.log('State', store.getState());
        throw err;
    }
};

const logger = store => next => action => {
    if (Configs.LOG_STATE) {
        console.log('dispatching', action);
    }
    const result = next(action);
    if (Configs.LOG_STATE) {
        console.log('next state', store.getState());
    }
    return result;
};


export const store = createStore(
    appReducer,
    applyMiddleware(logger, crashReporter),
);

export const persistor = persistStore(store);
